import { createFileRoute } from '@tanstack/react-router';

import { CornerLanguageSelector } from '@/components/corner-language-selector';
import { TermsPage } from '@/pages/terms/terms-page';

export const Route = createFileRoute('/terms')({
    component: TermsRoute,
});

// Local wrapper (NOT exported — route files export only Route). See
// routes/privacy.tsx for why the switcher mounts at the route level.
function TermsRoute() {
    return (
        <>
            <CornerLanguageSelector />
            <TermsPage />
        </>
    );
}
